"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATALOG_IMPORT_MAX_ROWS = void 0;
exports.CATALOG_IMPORT_MAX_ROWS = 10_000;
//# sourceMappingURL=catalog-import.js.map